// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yzOLJ","col":"styles_col__17WO6"};